/**
 * Names the two periods the Pace dropped diagnosis (EN-1006) compares, from `metrics.pace_window_days`:
 * "this week" and "last week" at the default of 7 days, otherwise the day counts, so the copy can't
 * contradict the evidence line when the window parameter is changed.
 *
 * Each phrase follows "a day", so the day-count forms carry their own preposition.
 */
export const pacePeriods = (days) => (days === 7
	? { recent: 'this week', previous: 'last week' }
	: { recent: `over the last ${days} days`, previous: `over the ${days} days before` });
